import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import InputFormik from "../../common/components/form/InputFormik";
import { maskPhone } from "../../common/helpers/mask.helpers";
import ButtonWithLoader from "../../common/components/ui/loading/ButtonLoading";
import {
  createLeadByAmbassador,
  getAmbassadorByCode,
} from "../../common/services/ambassador";
import { FaCheckCircle } from "react-icons/fa";
import Loading from "../../common/components/ui/loading/Loading";
import ComboBoxFormik from "../../common/components/form/ComboBoxFormik";
import { BiError } from "react-icons/bi";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome é obrigatório")
    .test(
      "full-name",
      "Deve incluir pelo menos um nome e um sobrenome",
      (value) => {
        if (!value) return false;
        const parts = value.split(" ");
        return parts.length >= 2;
      }
    ),
  whatsapp: Yup.string().required("Número do WhatsApp obrigatório"),
  companyId: Yup.string().required("Cidade é obrigatório"),
});

export default function CreateLeadByAmbassador() {
  const { ambassadorCode } = useParams();
  const [ambassador, setAmbassador] = useState<{
    cpf: string;
    name: string;
  }>();
  const [error, setError] = useState(false);
  const [form, setForm] = useState(true);

  const initialValues = {
    name: "",
    whatsapp: "",
  };

  useEffect(() => {
    async function fetchData() {
      if (ambassadorCode) {
        const result = await getAmbassadorByCode(ambassadorCode);
        const ambassador = result;
        setAmbassador(ambassador);
      }
    }

    fetchData();
  }, [ambassadorCode]);

  async function handleSubmit(dataToSave) {
    try {
      const lead = {
        ...dataToSave,
        code: ambassadorCode,
        cpfDoIndicador: ambassador?.cpf,
        nameAmbassador: ambassador?.name,
      };
      const result = await createLeadByAmbassador(lead);

      if (!result.ok) {
        throw new Error("Erro ao tentar salvar lead, tente novamente");
      }
      setForm(false);
      setError(false);
    } catch (err) {
      console.log(err);
      setForm(false);
      setError(true);
    }
  }

  const companies = [
    { value: "", label: "-" },
    { value: "66798791f9853d0018a5f3c7", label: "Anápolis" },
    { value: "667987c7f9853d0018a5f3ca", label: "Brasília" },
    { value: "6675839a31c5299c260f03af", label: "Campo Grande" },
    { value: "66798815f9853d0018a5f3cd", label: "Cuiabá" },
    { value: "667495f531c5299c260f0384", label: "Goiânia" },
    // { value: "66cf91fd9f2c83765d42836d", label: "Senador Canedo" },
    { value: "6679882af9853d0018a5f3ce", label: "Teresina" },
    { value: "6826103383d35312e760cf6e", label: "Rio Verde" },
    { value: "6827a6f2db9f2564a575e920", label: "Valparaíso de Goiás" },
    { value: "68fbb6d674c960298f3cbcfc", label: "Águas Lindas de Goiás" },
    { value: "687ba417a5c794a802dbc3f6", label: "Recife" },
    { value: "687ba437a5c794a802dbc3f7", label: "São Luís - Maranhão" },
    { value: "689768ca5e09ebf876c9d51c", label: "Campinas" },
    { value: "6679899ff9853d0018a5f3cf", label: "Uberlandia" }
  ];

  const backgroundElements = [
    {
      className:
        "mobile:z-20 laptop:z-0 z-20 absolute bottom-0 w-full h-[auto] min-h-[300px] bg-[url('../../../embaixador-bg.svg')] bg-bottom bg-no-repeat bg-cover",
    },
    {
      className:
        "mobile:z-20 laptop:hidden z-10 top-40 left-20 absolute w-3/6 h-[600px] bg-[url('../../../embaixador-logo-background1.svg')] opacity-20 bg-left bg-no-repeat bg-contain",
    },
    {
      className:
        "mobile:z-20 laptop:z-0 absolute w-[600px] h-[450px] mobile:w-[200px] mobile:h-[200px] z-40 bg-[url('../../../embaixador-moto-direita.svg')] right-0 bottom-52 laptop:bottom-0 mobile:bottom-0 bg-no-repeat bg-cover",
    },
    {
      className:
        "mobile:z-20 laptop:z-0 absolute w-[500px] h-[500px] mobile:w-[200px] mobile:h-[200px] z-40 bg-[url('../../../embaixador-moto-esquerda.svg')] left-0 bottom-20 laptop:bottom-0 mobile:bottom-32 bg-no-repeat bg-cover",
    },
    {
      className:
        "mobile:z-20 laptop:z-40 absolute w-[32%] h-[200px] laptop:w-[20%] laptop:h-[100px] mobile:w-[70%] z-40 bg-[url('../../../embaixador-titulo.svg')] top-10 laptop:top-5 bg-no-repeat bg-contain left-1/2 -translate-x-1/2",
    },
    {
      className:
        "mobile:z-20 laptop:z-40 absolute w-[40%] laptop:w-[20%] z-40 h-[220px] mobile:h-[140px] mobile:w-[70%] laptop:h-[80px] bg-[url('../../../embaixador-legenda.svg')] !bottom-0 bg-no-repeat bg-contain left-1/2 -translate-x-1/2",
    },
    {
      className:
        "mobile:hidden laptop:z-40 absolute w-[210px] h-[150px] laptop:w-[90px] laptop:h-[65px] z-40 right-20 top-20 bg-[url('../../../lv-logo.svg')] bg-no-repeat bg-cover",
    },
  ];

  return (
    <>
      {ambassador ? (
        <div className="relative flex justify-center items-center h-screen overflow-auto w-screen bg-black">
          {backgroundElements.map((element, index) => (
            <div key={index} className={element.className}></div>
          ))}

          <div className="relative w-3/6 mobile:w-5/6 !z-50 dark:text-black text-black flex flex-col justify-center items-center mx-auto custom-sm:max-w-80 bg-white p-4 rounded shadow-lg">
            <div className="p-2 text-black dark:text-black">
              {form && (
                <div className="mb-1 text-base">
                  <strong className="text-black dark:text-black">
                    Embaixador:
                  </strong>
                  <label className="text-sm text-black dark:text-black ms-1">
                    {ambassador?.name}
                  </label>
                </div>
              )}
              <span className="absolute left-0 top-0 text-black text-base">
                {!form && (
                  <button className="underline" onClick={() => setForm(true)}>
                    Cadastrar novo lead
                  </button>
                )}
              </span>
            </div>
            <div className="p-2 w-full">
              {form ? (
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, handleSubmit }) => {
                    return (
                      <Form className="text-base">
                        <ComboBoxFormik
                          label="Selecione a cidade onde deseja alugar sua moto:"
                          name="companyId"
                          options={companies}
                          required={true}
                        />
                        <InputFormik
                          label="Nome completo:"
                          name="name"
                          className="w-full"
                          required={true}
                        />
                        <InputFormik
                          label="WhatsApp:"
                          name="whatsapp"
                          type="whatsapp"
                          required={true}
                          mask={maskPhone}
                        />
                        <div className="flex mt-4 justify-end">
                          <ButtonWithLoader
                            isLoading={isSubmitting}
                            onClick={handleSubmit}
                          >
                            Enviar
                          </ButtonWithLoader>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              ) : (
                <>
                  {!error && (
                    <>
                      <div className="flex items-center mt-10 justify-center bg-gray-100">
                        <span className="text-2xl mb-4">
                          <FaCheckCircle className="text-greenPrimary" />
                        </span>
                      </div>
                      <div className="flex items-center justify-center bg-gray-100">
                        <span className="text-md text-center ml-2 mb-4">
                          Em breve entraremos em contato.
                        </span>
                      </div>
                    </>
                  )}
                  {error && (
                    <div className="flex flex-col items-center justify-center">
                      <BiError
                        style={{ color: "redPrimary" }}
                        className=" mr-2 w-20 h-20"
                      />
                      <span>Lead já cadastrado!</span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
}
